import type { ComponentPropsWithRef } from "react";
import Button, { type ButtonProps } from "@/components/ui/button.tsx";
import { cn } from "@/utils/style.ts";

export function ErrorContainer({ className, ...props }: ComponentPropsWithRef<"div">) {
    return <div {...props} className={cn("app error-loading-configurator", className)} />;
}

export function ErrorContent({ className, ...props }: ComponentPropsWithRef<"div">) {
    return <div {...props} className={cn("error-loading-configurator__content", className)} />;
}

export function ErrorMessage({ className, ...props }: ComponentPropsWithRef<"p">) {
    return <p {...props} className={cn("error-loading-configurator__message", className)} />;
}

export function ErrorAction({ className, ...props }: ButtonProps) {
    return <Button background="dark" {...props} className={cn("error-loading-configurator__action", className)} />;
}
